CustomRenderMixin = require 'components/mixins/custom_render_mixin'
ConnectStores = require 'components/enhancers/connect_store'
EtdActions = require 'actions/etd_actions'
EtdStore = require 'stores/etd_store'
EtdsStore = require 'stores/etds_store'
QuestionGroupsStore = require 'stores/question_groups_store'
QuestionsStore = require 'stores/questions_store'
RelatedRecommendationsModal = require 'components/etd/related_recommendations_modal'
Translation = require 'components/mixins/translation'

{ instanceOf, string, bool } = PropTypes

storeConnectors =
  EtdStore: (Store) ->
    relatedQuestionsIds: Store.getRelatedQuestionsIds()
    hiddenRelatedQuestions: Store.getHiddenRelatedQuestions()
  EtdsStore: (Store) ->
    etds: Store.getEtds()
  QuestionsStore: (Store) ->
    questions: Store.getQuestionsWithEtd()
  QuestionGroupsStore: (Store) ->
    questionGroups: Store.getQuestionGroups()

RelatedRecommendations = createReactClass

  displayName: "RelatedRecommendations"
  mixins: [
    CustomRenderMixin,
    Translation('')
  ]

  propTypes:
    relatedQuestionsIds: instanceOf(Immutable.List).isRequired
    hiddenRelatedQuestions: instanceOf(Immutable.Map).isRequired
    questions: instanceOf(Immutable.Map).isRequired
    questionGroups: instanceOf(Immutable.Map).isRequired
    editable: bool

  getInitialState: ->
    showRRModal: false

  updateRelatedQuestionsIds: (relatedQuestionsIds) ->
    EtdActions.updateRelatedQuestionsIds relatedQuestionsIds
    @setState showRRModal: false

  openRRModal: ->
    @setState showRRModal: true

  closeRRModal: ->
    @setState showRRModal: false

  render: ->
    {
      editable
      etds
      hiddenRelatedQuestions
      questions
      questionGroups
      relatedQuestionsIds
    } = @props

    buttonLabel = if relatedQuestionsIds.isEmpty()
      'actions.add_related_recommendations'
    else
      'actions.edit_related_recommendations'

    <div className="related-recommendations">
      <div className="flex items-center gap-10">
        <button className="btn btn-add" onClick={@openRRModal} disabled={not editable}>
          {@i18n buttonLabel}
        </button>
        {@state.showRRModal and
          <RelatedRecommendationsModal
            questions={questions}
            questionGroups={questionGroups}
            relatedQuestionsIds={relatedQuestionsIds}
            updateRelatedQuestionsIds={@updateRelatedQuestionsIds}
            onClose={@closeRRModal}
          />
        }
      </div>
    </div>

module.exports = ConnectStores RelatedRecommendations,
  [EtdStore, EtdsStore, QuestionsStore, QuestionGroupsStore], storeConnectors
